// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { navy } from '@zocdoc/branding/colors';

// Icon code
import { Icon } from './_base';

const ConfirmedSVG = styled(Icon).attrs({ viewBox: '0 0 38 40' })`
    width: 0.95em;
`;

const Confirmed = ({ color = navy, ...props }) => (
    <ConfirmedSVG data-test="icon-confirmed" {...props}>
        <path
            d="M33.15,21.48c0,0.46,0,.91-0.06,1.36A14.14,14.14,0,1,1,26.47,9.46l2.31-3.71a18.45,18.45,0,0,0-7.25-2.62V0H16.47V3.14a18.52,18.52,0,1,0,21,20.12c0.06-.58.08-1.18,0.08-1.78H33.15Z"
            fill={color}
        />
        <polygon
            fill={color}
            points="18.51 19.13 14.14 19.13 14.14 29.24 19.41 29.24 35.66 12.99 32.57 9.9 18.51 23.95 18.51 19.13"
        />
    </ConfirmedSVG>
);

export { Confirmed as default, Confirmed };
